import { apiClient } from './api/client';

export async function createGuestInvite(payload) {
  return apiClient.post('/api/meetings/guest-invites', payload);
}

export async function listGuestInvites() {
  return apiClient.get('/api/meetings/guest-invites');
}

export async function listGuestInvitesExec(params = {}) {
  return apiClient.get('/api/executive/guest-invites', { params });
}

export async function patchGuestInviteExec(inviteId, payload) {
  return apiClient.patch(`/api/executive/guest-invites/${inviteId}`, payload);
}

export async function sendGuestInviteExec(inviteId) {
  return apiClient.post(`/api/executive/guest-invites/${inviteId}/send`, {});
}

// Bethany's team's conflict review. This is the decision the $30 fee request
// and the guest welcome both wait on, so it has its own endpoint and records
// who decided and when.
export async function recordGuestConflictDecision(inviteId, decision) {
  return apiClient.patch(`/api/executive/guest-invites/${inviteId}/conflict`, { decision });
}

// Meetings a guest may register for. Public: the self-registration form has to
// offer the same choice a member gets (§4.1).
export async function listMeetingsOpenForGuests() {
  return apiClient.get('/api/meetings/open-for-guests');
}
